export default {
  OPEN_RESERVATION_CONTRACT_MODAL: 'OPEN_RESERVATION_CONTRACT_MODAL',
  OPEN_RESERVATION_CONTRACT_MODAL_SUCCESS: 'OPEN_RESERVATION_CONTRACT_MODAL_SUCCESS',
  CLOSE_RESERVATION_CONTRACT_MODAL: 'CLOSE_RESERVATION_CONTRACT_MODAL',
  CLOSE_RESERVATION_CONTRACT_MODAL_SUCCESS: 'CLOSE_RESERVATION_CONTRACT_MODAL_SUCCESS'
}
